"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addGlobals = exports.hooks = void 0;
const feature_1 = require("./feature");
const plugable_record_1 = require("../helpers/plugable-record");
const selector_1 = require("../helpers/selector");
const dataKey = plugable_record_1.plugableRecord.key('globals');
// HOOKS
exports.hooks = (0, feature_1.createFeature)({
    metaInit({ meta }) {
        plugable_record_1.plugableRecord.set(meta.data, dataKey, {});
    },
});
// API
function addGlobals(meta, selectorAst) {
    for (const ast of selectorAst) {
        (0, selector_1.walkSelector)(ast, (inner) => {
            if (inner.type === 'class') {
                meta.globals[inner.value] = true;
            }
        });
    }
}
exports.addGlobals = addGlobals;
//# sourceMappingURL=st-global.js.map